import { Message } from "@/app/store/types";
import React from "react";
import styles from "./MsgEnd.module.scss";
import { tryParse } from "@/app/utils/object";
interface IProps {
  msg: Message;
}

export default function MsgEnd(props: IProps) {
  const content = tryParse(props.msg.content);
  if (!content) {
    return;
  }
  return (
    <p
      className={styles.endMsg}
      dangerouslySetInnerHTML={{ __html: content.text }}
    ></p>
  );
}
